<script>
    
    import { createEventDispatcher } from 'svelte'
    import Button from './button.svelte'

    const dispatch = createEventDispatcher()

    export let loading = false
    
    let isClicked = false
    let text = 'Borrar'
    let color = null

    function verifyClicked() {

        if(!isClicked) {
            isClicked = true
            color = 'danger'
            text = 'Click para confirmar'
            setTimeout(reset, 3000);
        } else {
            dispatch('confirm')
            reset()
        }
    }

    function reset() {
        isClicked = false
        color = null
        text = 'Borrar'
    }
    
</script>


<Button on:click={verifyClicked} icon="trash" { text } { color } {loading} size="small" />